const gauge = 10;
const line_radius = 10;
const handleLength = 45;
const handleWidth = 15;
export { gauge, line_radius, handleLength, handleWidth };
